import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post, put } from "../../api/client";
import queryClient from "../../config/queryClient";
import { SubjectPayloadInterface } from "../../Constants/Interfaces/payloadInterface/SubjectPayload.interface";

const key = {
  ALL_SUBJECT_OPTIONS: "ALL_SUBJECT_OPTIONS",
  ALL_SUBJECTS: "ALL_SUBJECTS",
};

export const useSubjectByClassIdOptions = ({
  classId,
}: {
  classId: number | null;
}) =>
  useQuery([classId], () =>
    get({ url: `api/v1/subjects/options/`, params: { classId } })
  );

export const useAllSubjectClassOptions = () =>
  useQuery([key.ALL_SUBJECT_OPTIONS], () =>
    get({ url: `api/v1/subjects/all-subjects/options` })
  );

export const useGetAllSubjects = ({ page }: { page: number }) =>
  useQuery([key.ALL_SUBJECTS, page], () =>
    get({
      url: `api/v1/subjects`,
      params: {
        page,
      },
    })
  );

export const useAddSubject = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) =>
  useMutation(
    (body: SubjectPayloadInterface) => {
      return post({ url: "api/v1/subjects", body });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [key.ALL_SUBJECTS],
        });
        onSuccess();
      },
      onError,
    }
  );

export const useUpdateSubject = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) =>
  useMutation(
    ({
      subjectId,
      body,
    }: {
      subjectId: number;
      body: SubjectPayloadInterface;
    }) => {
      return put({ url: `api/v1/subjects/${subjectId}`, body });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [key.ALL_SUBJECTS],
        });
        onSuccess();
      },
      onError,
    }
  );
